(function ($) {
    class rAccordion {
        constructor(elem, settings) {
            this.$elem = $(elem);
            this.$head = $(elem).find('.js-accordion-header');
            this.$body = $(elem).find('.js-accordion-body');
            this.set = settings['set'];
            this.query = settings['query'];
            this.speed = settings['speed'];
            this.state = false;
            this.active = settings['active'],
            this.enableLink = settings['link'];
            this.collapsible = settings['collapsible'];

            this.createOrDestroy();

            if (this.query) {
                $(window).on('resize', () => this.createOrDestroy());
            }

            this.$head.on('click', () => this.$head.trigger('headClicked'));
        }

        create() {
            this.$head.on('headClicked', (event) => this.toggleBody(event));
            if (!this.getActiveState()) {
                this.$body.hide();
            } else {
                this.$head.addClass('is-active');
            }

            this.state = true;

            this.$elem.addClass('accordion-is-active');
        }

        destroy() {
            this.$head.off('headClicked');
            this.$body.show();

            this.state = false;

            this.$elem.removeClass('accordion-is-active');
            this.$head.removeClass('is-active');

        }

        createOrDestroy() {
            if (this.getAccordionState()) {
                if (!this.$elem.hasClass('accordion-is-active')) {
                    this.create();
                }
            } else if (this.$elem.hasClass('accordion-is-active')) {
                this.destroy();
            }
        }

        getActiveState(query = this.active) {
            let active = false;

            if (!query) {
                return false;
            }

            if (query === true) {
                return true;
            }

            for (let value of query.split(';')) {
                if ($('.c-var .' + value + '-is-visible').is(':visible')) {
                    active = true;
                }
            }

            return active;
        }

        getAccordionState(query = this.query) {
            let state = false;

            if (!query) {
                return true;
            }

            for (let value of query.split(';')) {
                if ($('.c-var .' + value + '-is-visible').is(':visible')) {
                    state = true;
                }
            }

            return state;
        }

        toggleBody(event, set = this.set) {
            if ($(event.target).closest('a').length && !this.enableLink) {
                event.preventDefault();
            }

            if (this.$head.hasClass('is-active')) {
                this.hideBody();
            } else {
                this.showBody();

                if (set && this.collapsible) {
                    for (let accordion of Array.from(rui.rAccordions)) {
                        if (accordion.set == set && accordion.state && accordion != this) {
                            accordion.hideBody();
                        }
                    }
                }
            }
        }

        showBody() {
            this.$body.stop().slideDown(this.speed);

            this.$head.addClass('is-active');
        }

        hideBody() {
            this.$body.stop().slideUp(this.speed);

            this.$head.removeClass('is-active');
        }
    }

    $.fn.rAccordion = function (options) {
        return this.each(function () {
            let settings = $.extend({
                query: false,
                set: false,
                speed: 250,
                active: false,
                link: false,
                collapsible: true
            }, options, $(this).data());

            rui.rAccordions.push(new rAccordion(this, settings));
        });
    }
})(jQuery);

$(function () {
    $('.js-accordion').rAccordion();
});
